import { Input } from '@unified-checkout/design-system';
import { PAYME_BASE_URL } from '@app/dashboard/constants/payme-links';
import styles from './payme-handle-input.module.scss';

export interface PayMeHandleInputProps {
  id?: string;
  name?: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  status?: 'default' | 'error' | 'warning' | 'success';
  trailingIcon?: React.ReactNode;
  className?: string;
}

export const PayMeHandleInput = ({
  id = 'payme-handle',
  name = 'payme-handle',
  value,
  onChange,
  placeholder,
  disabled = false,
  error,
  status = 'default',
  trailingIcon,
  className,
}: PayMeHandleInputProps) => {
  return (
    <div className={`${styles['payme-handle-input']} ${className || ''}`}>
      <Input
        id={id}
        name={name}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        leadingText={`${PAYME_BASE_URL?.length || 0 > 27 ? `...${PAYME_BASE_URL?.split('//')[1].slice(8)}` : PAYME_BASE_URL}/`}
        trailingIcon={trailingIcon}
        disabled={disabled}
        status={error || status === 'error' ? 'error' : status}
        error={error}
      />
    </div>
  );
};

